import type { QueryClient } from '@tanstack/react-query'
import { MEETING_FOLLOW_UPS_QUERY_KEY, REMINDERS_QUERY_KEY } from './reminder-query-keys'

export function subscribeMeetingFollowUpsSync(queryClient: QueryClient, onError: (error: unknown) => void): () => void {
  let queued = false
  let active = true
  const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
    if (
      event.type !== 'updated' ||
      event.action.type !== 'success' ||
      event.query.queryKey[0] !== REMINDERS_QUERY_KEY ||
      queued
    ) {
      return
    }
    queued = true
    queueMicrotask(() => {
      queued = false
      if (!active) {
        return
      }
      void queryClient.invalidateQueries({ queryKey: [MEETING_FOLLOW_UPS_QUERY_KEY] }).catch(onError)
    })
  })

  return () => {
    active = false
    unsubscribe()
  }
}
